import { Component, OnInit } from '@angular/core';
import { DeviceDetectorService, DeviceType } from 'src/app/shared/services/device-detector.service';
import { EventEmitterService } from 'src/app/shared/services/event-emitter.service';

@Component({
    selector: 'cmp-layout-content',
    templateUrl: './content.component.html',
    styleUrls: ['./content.component.less'],
    standalone: false
})
export class ContentComponent implements OnInit {
  public isToggle: boolean = false;
  deviceType :DeviceType;

  constructor(
    private emitter: EventEmitterService, private deviceDetectorService: DeviceDetectorService
  ) { 
    this.deviceDetectorService.deviceType$.subscribe((deviceType: DeviceType) => {
      this.deviceType = deviceType;
    });
    this.deviceType = this.deviceDetectorService.getCurrentDeviceType();
  }

  ngOnInit(): void {
    this.emitter.invokeToggle.subscribe(res => {
      this.isToggle = res;
    });
  }

  toggle() {
    this.isToggle = !this.isToggle;
    console.log('Toggling to:', this.isToggle);
    this.emitter.onToggle(this.isToggle);
    
  }
}
